import(/* webpackMode: "eager" */ "/home/ubuntu/download_production/6a778bf88295d500147a7e82_1787311767166_4cae310c/brainbasket/src/app/admin/page.tsx");
